
  import DataFab from '@/components/datafab/datafab.vue'
  import StudentModal from './StudentModal.vue'
  import TemplateModal from '../student/templateModal.vue'
  import {
    ClosePopup,
    Dialog,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QBtn,
    QCard,
    QCheckbox,
    QHeader,
    QItem,
    QList,
    QMenu,
    QPage,
    QSelect,
    QSeparator,
    QSpinner,
    QTable,
    QTd,
    QTooltip,
    QTr
  } from 'quasar'
  import ImportModal from './importModal.vue'
  import ChangeGroupModal from './ChangeGroupModal.vue'
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  import { dateUtils } from '@parantion/components'

  const { convertDateFormatToISO_8601: dateFormat } = dateUtils

  interface Student {
    firstname: '',
    middlename: '',
    lastname: '',
    email: '',
    gd_ibnaam: '',
    gd_ibemail: '',
    status: 'active',
    birthdate: ''
  }

  @Component({
    directives: { ClosePopup },
    components: {
      StudentModal,
      ImportModal,
      ChangeGroupModal,
      TemplateModal,
      DataFab,
      QPage,
      QBreadcrumbs,
      QSelect,
      QItem,
      QMenu,
      QSeparator,
      QCheckbox,
      QBreadcrumbsEl,
      QBtn,
      QCard,
      QTable,
      QTd,
      QTooltip,
      QTr,
      QSpinner,
      QList,
      QHeader
    }
  })
  export default class Students extends Vue {
    @Prop({ type: String, required: true }) groupName: string /* gets passed by url param */
    searchModel = ''
    student: Student = {
      firstname: '',
      middlename: '',
      lastname: '',
      email: '',
      gd_ibnaam: '',
      gd_ibemail: '',
      status: 'active',
      birthdate: ''
    }

    translationState = this.$getTranslationOptions()
    columns = createColumns(this.$t)
    pagination = {
      sortBy: 'firstname',
      descending: false,
      page: 1,
      rowsPerPage: 50 // current rows per page being displayed
    }

    actionsConfig = {
      primary: {
        icon: 'assignment', tooltip: 'tooltip.gotostudent.1', handler: student => this.goToStudent(student)
      },
      actions: [
        { icon: 'edit', tooltip: 'Gegevens wijzigen', handler: student => this.editStudent(student) },
        {
          icon: 'exit_to_app',
          tooltip: this.$t('manage_groups_dialog.manage_groups.tooltip'),
          handler: student => this.removeStudent(student)
        }
      ]
    }

    actionsSansEditConfig = {
      primary: {
        icon: 'assignment', tooltip: 'tooltip.gotostudent.1', handler: student => this.goToStudent(student)
      },
      actions: [
        /* {
           icon: 'exit_to_app',
           tooltip: 'Leerling uit groep verwijderen',
           handler: student => this.removeStudent(student)
         } */
      ]
    }

    createdStudent = {}
    $router: any

    @Watch('translationState', { immediate: true })
    translationStateWatcher () {
      this.columns = createColumns(this.$t)
    }

    created () {
      this.$store.dispatch('groups/retrieveGroups')
      this.$store.dispatch('base/retrieveRights')
      this.$store.dispatch('base/retrieveTemplates')
      this.$store.dispatch('import/retrieveGroups')
      this.$store.dispatch('import/retrieveUsersFromGroups', this.groupName)
      this.$store.dispatch('groups/retrieveUsersFromGroups', { groupName: this.groupName })
    }

    async importUsers (users) {
      try {
        for (const user of users) {
          user.groupname = this.groupName
          const uh = await this.$store.dispatch('import/importUser', user)
          user.uh = uh
        }

        setTimeout(async () => {
          let selectedTemplate
          if (this.formTemplates.length === 1) {
            selectedTemplate = this.formTemplates[0]
          } else {
            const selected = await new Promise((resolve, reject) => {
              this.$q.dialog({
                title: this.$t('template.create_groeidocument.templatemodal'),
                message: this.$t('template.select_template.templatemodal'),
                ok: true, // takes i18n value, or String for "OK" button label
                cancel: true, // takes i18n value, or String for "Cancel" button label
                preventClose: true,
                options: {
                  type: 'radio', // or 'checkbox' / 'toggle'
                  model: this.formTemplates[0].value, // Array when checkbox/toggle! (like '[]')
                  items: this.formTemplates
                }
              })
                      .onOk((res) => resolve(res))
            })
            if (!selected) return
            selectedTemplate = this.formTemplates.find(t => t.value === selected)
          }

          for (const user of users) {
            this.templateSelected(selectedTemplate, user)
          }
        }, 200)
      } catch (e) {
        console.warn(e)
      }
      this.importModalRef.hide()
      this.refresh()
    }

    selected (sel) {
      console.log(sel.ding)
    }

    createStudent () {
      this.student = {
        firstname: '',
        middlename: '',
        lastname: '',
        email: '',
        gd_ibnaam: '',
        gd_ibemail: '',
        status: 'active',
        birthdate: ''
      }
      this.studentModalRef.open()
    }

    async templateSelected (template, student) {
      student = student || this.createdStudent
      await this.$store.dispatch('groups/addDocument', {
        module: 'Form',
        users: [student.uid || student.uh],
        template: template.value,
        frm_label: template.label
      })

      student.formCount = 1
      this.refresh()

      this.templateModalRef.close()
    }

    async submitStudent ({ student, updatedFields }) {
      if (student.uh) { // existing student
        await this.$store.dispatch('groups/updateUser', { student, updatedFields }).catch(e => {
          this.$toasty.error('Er is iets misgegaan. Probeer het later nog eens.')
        })
        .then(() => {
          this.$toasty.success('Veld(en) bijgewerkt.')
        })
      } else {
        await this.$store.dispatch('groups/addStudentToGroup', { student, groupName: this.groupName })
        setTimeout(() => {
          if (this.formTemplates.length === 1) {
            this.templateSelected(this.formTemplates[0], student)
          } else {
            this.templateModalRef.open()
          }
        }, 200)
        this.createdStudent = student
      }

      this.studentModalRef.close()
    }

    async editStudent (student) {
      student = this.students.find(s => s.uh === student.uh)
      const fields = await this.$store.dispatch('groups/getUserFields', student.uh)
      fields.status = fields.status[0].name
      this.student = Object.assign(student, fields)

      this.studentModalRef.open()
    }

    async removeStudent (student) {
      this.student = student

      let groups = await this.$store.dispatch('groups/getGroupsOfUser', student.uh)
      groups = groups[0][student.uh].map(g => g.name)

      try {
        Dialog.create({
          title: this.$t('manage_groups_dialog.manage_groups.modal'),
          message: this.$t('manage_groups_dialog.manage_groups_body.modal'),
          ok: true,
          cancel: true, // takes i18n value, or String for "Cancel" button label
          preventClose: true,
          options: {
            type: 'checkbox', // or 'checkbox' / 'toggle'
            model: groups, // Array when checkbox/toggle! (like '[]')
            items: this.groups
          }
        }).onOk(async (res) => {
          try {
            if (res.length === 0) {
              Dialog.create({
                title: this.$t('manage_groups_dialog.are_you_sure.modal'),
                message: this.$t('manage_groups_dialog.student_no_group.modal', { name: `${student.firstname} ${student.middlename || ''} ${student.lastname}` }),
                preventClose: true,
                ok: false,
                cancel: {
                  flat: true,
                  label: this.$t('manage_groups_dialog.back.modal'),
                  color: 'primary'
                }
              })
            } else {
              await this.$store.dispatch('groups/changeStudentToGroup', { student: student, currentGroups: groups, newGroupNames: res })
              this.refresh()
            }
          } catch (e) {}
        })
      } catch (e) {
      }
    }

    goToStudent (student) {
      this.$store.commit('groups/SET_STUDENT', student)
      // eslint-disable-next-line
      this.$router.push({ path: '/groups/students/' + this.groupName + '/student/' + student.uh })
    }

    async refresh () {
      await this.$store.dispatch('groups/retrieveGroups', { force: true })
      this.$store.dispatch('groups/retrieveUsersFromGroups', { groupName: this.groupName, options: { force: true } })
      this.$store.dispatch('base/retrieveTemplates', { force: true })
    }

    get isFetchingUsers (): boolean {
      return this.$store.state.groups.fetchingUsers
    }

    get importModalRef (): Vue | any {
      return this.$refs.importModal
    }

    get canCreateStudent () {
      // @ts-ignore
      return this.$can('create', 'Student')
    }

    get studentModalRef (): Vue | any {
      return this.$refs.studentModal
    }

    get templateModalRef (): Vue | any {
      return this.$refs.templateModal
    }

    get formTemplates () {
      return this.$store.state.base.templates.filter(t => t.type === 'form').map(t => ({
        label: t.label,
        value: t.tn
      }))
    }

    get isImported () {
      return this.$store.state.import.groups.some(g => g.name === this.groupName)
    }

    get group () {
      return this.$store.getters['groups/getGroupByName'](this.groupName)
    }

    get groups () {
      let groups = this.$store.state.groups.groups
      groups = groups.filter(group => group.member === 0)
      return groups.map(t => ({
        label: t.label,
        value: t.name
      }))
    }

    get importStudents () {
      return this.$store.getters['import/usersFromGroup'](this.groupName).filter(s => {
        // return !this.students.map(x => x.username).includes(s.username)
        return !this.students.map(x => x.username).includes(s.username)
      })
    }

    get loading () {
      return !this.$store.state.groups.users[this.groupName]
    }

    get students () {
      let students = this.$store.getters['groups/usersFromGroup'](this.groupName)

      if (this.searchModel) {
        students = students.filter(s => (s.firstname && s.firstname.toLowerCase().includes(this.searchModel.toLowerCase())) || (s.middlename && s.middlename.toLowerCase().includes(this.searchModel.toLowerCase())) || (s.lastname && s.lastname.toLowerCase().includes(this.searchModel.toLowerCase())))
      }

      const importedUsers = this.$store.getters['import/usersFromGroup'](this.groupName).map(g => g.username)

      return students.map(student => {
        student.imported = importedUsers.includes(student.username)
        return student
      })
    }
  }

  function createColumns ($t) {
    return [
      {
        label: $t('studenttable.firstname.label'),
        field: 'firstname',
        name: 'firstname',
        sortable: true,
        align: 'left'
      },
      {
        label: $t('studenttable.middlename.label'),
        field: 'middlename',
        name: 'middlename',
        sortable: true,
        align: 'left'
      },
      {
        label: $t('studenttable.lastname.label'),
        field: 'lastname',
        name: 'lastname',
        sortable: true,
        align: 'left'
      },
      {
        label: $t('studenttable.created.label'),
        field: 'created',
        name: 'created',
        sortable: true,
        format: val => val ? dateFormat(val, 'dd-MM-yyyy HH:mm') : '',
        align: 'left'
      },
      {
        label: $t('studenttable.status.label'),
        sortable: true,
        name: 'status',
        type: 'string',
        filter: true,
        field: 'status'
      },
      {
        label: $t('studenttable.actions.label'),
        classes: 'action-column',
        name: 'actions',
        align: 'right',
        field: 'message',
        width: '200px'
      }
    ]
  }

